import React from 'react';

/** Header cell look, shared by every table in the dashboard. */
export const thClass =
  'h-10 border-b border-ui-line bg-ui-muted px-4 text-left text-[11px] font-semibold tracking-wider text-ui-ink-3 uppercase whitespace-nowrap';

/** Body cell look. */
export const tdClass = 'border-b border-ui-line-soft px-4 py-3 text-sm text-ui-ink align-middle';

/**
 * A plain table: header row from `head`, rows as children (`<tr><td className={tdClass}>…`).
 * It scrolls sideways inside its card when it is wider than the page.
 *
 * @param {Object} props
 * @param {React.ReactNode[]} props.head - Column titles
 * @param {number[]} props.rightAlign - Indexes of columns whose header sits on the right (amounts)
 */
const Table = ({ head, rightAlign = [], className = '', children }) => {
  return (
    <div className={`ui-scroll overflow-x-auto ${className}`}>
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr>
            {head.map((columnTitle, columnIndex) => (
              <th
                key={columnIndex}
                scope="col"
                className={`${thClass} ${rightAlign.includes(columnIndex) ? 'text-right' : ''}`}
              >
                {columnTitle}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="[&>tr:hover]:bg-ui-muted [&>tr:last-child>td]:border-b-0">{children}</tbody>
      </table>
    </div>
  );
};

export default Table;
